/* Preview template product.orbit-v2: use-case chips, pack progress bar and GPS savings calculator. */
(() => {
  // Use-case chips jump the gallery to a photo.
  document.querySelectorAll('[data-v2-chips]').forEach((wrap) => {
    const section = wrap.closest('section');
    const gallery = section && section.querySelector('apl-gallery');
    wrap.querySelectorAll('[data-photo]').forEach((chip) => {
      chip.addEventListener('click', () => {
        const n = Number(chip.dataset.photo) - 1;
        if (gallery && gallery.show && n >= 0) gallery.show(n);
        wrap.querySelectorAll('[data-photo]').forEach((c) => c.classList.toggle('is-active', c === chip));
        if (window.matchMedia('(max-width: 989px)').matches && gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });

  // Pack progress bar: what's unlocked now and what the next pack adds.
  document.querySelectorAll('[data-v2-progress]').forEach((bar) => {
    const mix = bar.closest('apl-mix, apl-packs');
    if (!mix) return;
    const tiers = JSON.parse(bar.querySelector('[data-v2-tiers]').textContent).map((t) => {
      const [q, p] = t.split(':');
      return { qty: Number(q), pct: Number(p) };
    });
    const msg = bar.querySelector('[data-v2-msg]');
    const steps = Array.from(bar.querySelectorAll('[data-v2-step]'));
    const packs = Array.from(mix.querySelectorAll('input[type=radio][data-pct]'));
    const update = () => {
      const picked = packs.find((p) => p.checked);
      const qty = picked ? Number(picked.value) : 1;
      const cur = tiers.find((t) => t.qty === qty) || tiers[0];
      const next = tiers.find((t) => t.qty > qty);
      steps.forEach((s) => s.classList.toggle('is-done', Number(s.dataset.v2Step) <= qty));
      const last = tiers[tiers.length - 1];
      bar.style.setProperty('--v2-fill', String(tiers.indexOf(cur) / Math.max(1, tiers.length - 1)));
      const labelFor = (t) => { const r = packs.find((p) => Number(p.value) === t.qty); return r ? r.dataset.label || '' : ''; };
      let text = '';
      if (cur.pct > 0) text += (labelFor(cur) || cur.pct + '% off') + ' unlocked. ';
      const one = bar.dataset.unit || 'tracker';
      const many = bar.dataset.units || 'trackers';
      if (next) text += 'Add ' + (next.qty - qty) + ' more ' + (next.qty - qty > 1 ? many : one) + (labelFor(next) ? ': ' + labelFor(next) + '.' : ' to save ' + next.pct + '%.');
      else text += bar.dataset.bonus || ('Best value: ' + last.qty + ' ' + many + '.');
      msg.textContent = text;
    };
    packs.forEach((p) => p.addEventListener('change', update));
    update();
  });

  // GPS plan savings calculator.
  document.querySelectorAll('[data-v2-calc]').forEach((calc) => {
    const fmt = calc.dataset.money || '${{amount}}';
    const money = (cents) => fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US')).replace(/<[^>]*>/g, '');
    const price = Number(calc.dataset.price);
    const fee = calc.querySelector('[data-v2-fee]');
    const months = calc.querySelector('[data-v2-months]');
    const out = (k, v) => calc.querySelectorAll('[data-v2-out="' + k + '"]').forEach((el) => { el.textContent = v; });
    const update = () => {
      const plan = Number(fee.value) * 100 * Number(months.value);
      out('fee', money(Number(fee.value) * 100) + '/mo');
      out('months', months.value + ' months');
      out('plan', money(plan));
      out('keep', money(Math.max(0, plan - price)));
      const max = Math.max(plan, price) || 1;
      calc.style.setProperty('--v2-plan', (plan / max * 100) + '%');
      calc.style.setProperty('--v2-ours', Math.max(4, price / max * 100) + '%');
    };
    [fee, months].forEach((el) => el.addEventListener('input', update));
    update();
  });
})();
